module.exports = {
	"assistive_tech": [
		{
			"detail": "",
			"id": 1,
			"name": "Upper Extremity Prosthetics",
			"order": 1000
		},
		{
			"detail": "",
			"id": 2,
			"name": "Lower Extremity Prosthetics",
			"order": 1000
		},
		{
			"detail": "",
			"id": 3,
			"name": "Hearing Aid",
			"order": 1000
		},
		{
			"detail": "",
			"id": 4,
			"name": "White Cane",
			"order": 1000
		},
		{
			"detail": "",
			"id": 5,
			"name": "Service Animals",
			"order": 1000
		},
		{
			"detail": "",
			"id": 6,
			"name": "Smart Phone",
			"order": 1000
		},
		{
			"detail": "",
			"id": 7,
			"name": "Wheelchair",
			"order": 1000
		},
		{
			"detail": "",
			"id": 8,
			"name": "Walker",
			"order": 1000
		},
		{
			"detail": "",
			"id": 9,
			"name": "Cane/Crutch",
			"order": 1000
		},
		{
			"detail": "",
			"id": 10,
			"name": "Scooter",
			"order": 1000
		},
		{
			"detail": "",
			"id": 11,
			"name": "Medical Implant",
			"order": 1000
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/Profile/AssistiveTechnology.json
// module id = 1091
// module chunks = 0